import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { reducer as form } from 'redux-form'
import { reducer as notifications } from 'react-notification-system-redux'
import { responsiveStateReducer } from 'redux-responsive'
import adminActivities from '../routes/authenticated/AdminDashboard/adminActivitiesDuck'
import adminInvitations from '../routes/authenticated/AdminDashboard/adminInvitationsDuck'
import adminSubordinates from '../routes/authenticated/AdminDashboard/adminSubordinatesDuck'
import adminTasksAssignment from '../routes/authenticated/AdminDashboard/adminTasksAssignmentDuck'
import career from '../routes/authenticated/Search/routes/Career/careerDuck'
import contactUs from '../routes/authenticated/UserProfile/contactUsDuck'
import dashboardTasks from '../routes/authenticated/Dashboard/dashboardTasksDuck'
import demo from '../routes/authenticated/Demo/demoDuck'
import feed from '../routes/authenticated/Dashboard/feedDuck'
import forgotPassword from '../routes/unauthenticated/ForgotPassword/forgotPasswordDuck'
import insToken from '../routes/unauthenticated/Onboarding/insTokenDuck'
import jobSearch from '../routes/authenticated/JobSearch/jobSearchDuck'
import login from '../routes/unauthenticated/Login/loginDuck'
import outcomes from '../routes/authenticated/Outcomes/outcomesDuck'
import payment from '../routes/unauthenticated/Onboarding/paymentDuck'
import personalityAssessment from '../routes/authenticated/PersonalityAssessment/personalityAssessmentDuck'
import resetPassword from '../routes/unauthenticated/ResetPassword/resetPasswordDuck'
import savedCareerSearches from '../routes/authenticated/Search/routes/Career/savedCareerSearchesDuck'
import savedEducationSearches from '../routes/authenticated/Search/routes/Education/savedEducationSearchesDuck'
import savedJobs from '../routes/authenticated/JobSearch/savedJobsDuck'
import savedTuitionSearches from '../routes/authenticated/Tuition/savedTuitionSearchesDuck'
import searchHistory from '../components/ui/SearchHistory/searchHistoryDuck'
import signup from '../routes/unauthenticated/Signup/signupDuck'
import skillsInfo from '../routes/authenticated/Search/skillsInfoDuck'
import studentActivities from '../routes/authenticated/ParentDashboard/studentActivitiesDuck'
import studentInvitations from '../routes/authenticated/ParentDashboard/studentInvitiationsDuck'
import studentSignups from '../routes/authenticated/ParentDashboard/studentSignupsDuck'
import studentTasksAssignment from '../routes/authenticated/ParentDashboard/studentTasksAssignmentDuck'
import subscriptionCancellation from '../components/ui/SubscriptionCancellation/subscriptionCancellationDuck'
import tuition from '../routes/authenticated/Tuition/tuitionDuck'
import userProfile from '../routes/authenticated/UserProfile/userProfileDuck'
import interestSelector from '../components/ui/InterestSelector/interestSelectorDuck'
import currentUser from './shared/currentUserDuck'
import taskTypes from './shared/taskTypesDuck'

export const RESET = 'steppingblocks/root/reset'

const appReducer = combineReducers({
  adminActivities,
  adminInvitations,
  adminSubordinates,
  adminTasksAssignment,
  browser: responsiveStateReducer,
  career,
  contactUs,
  currentUser,
  dashboardTasks,
  demo,
  feed,
  forgotPassword,
  form,
  insToken,
  interestSelector,
  jobSearch,
  login,
  notifications,
  outcomes,
  payment,
  personalityAssessment,
  resetPassword,
  routing: routerReducer,
  savedCareerSearches,
  savedEducationSearches,
  savedJobs,
  savedTuitionSearches,
  searchHistory,
  signup,
  skillsInfo,
  studentActivities,
  studentInvitations,
  studentSignups,
  studentTasksAssignment,
  subscriptionCancellation,
  taskTypes,
  tuition,
  userProfile,
})

export default (state, action) => {
  let newState = state
  if (action.type === RESET) {
    newState = {}
  }

  return appReducer(newState, action)
}



// WEBPACK FOOTER //
// ./src/store/rootReducer.js